import React from 'react';

import { cn } from '@heidi/utils';

import { typographyVariant } from './typography.styles';
import type { TypographyProps } from './typography.types';

export const TypographyH1 = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h1
        ref={ref}
        className={cn(typographyVariant({ variant: 'h1', className }))}
        {...props}
      >
        {children}
      </h1>
    );
  }
);
TypographyH1.displayName = 'TypographyH1';

export const TypographyH2 = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h2
        ref={ref}
        className={cn(typographyVariant({ variant: 'h2', className }))}
        {...props}
      >
        {children}
      </h2>
    );
  }
);
TypographyH2.displayName = 'TypographyH2';

export const TypographyH3 = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h3
        ref={ref}
        className={cn(typographyVariant({ variant: 'h3', className }))}
        {...props}
      >
        {children}
      </h3>
    );
  }
);
TypographyH3.displayName = 'TypographyH3';

export const TypographyH4 = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h4
        ref={ref}
        className={cn(typographyVariant({ variant: 'h4', className }))}
        {...props}
      >
        {children}
      </h4>
    );
  }
);
TypographyH4.displayName = 'TypographyH4';

export const TypographyH5 = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h5
        ref={ref}
        className={cn(typographyVariant({ variant: 'h5', className }))}
        {...props}
      >
        {children}
      </h5>
    );
  }
);
TypographyH5.displayName = 'TypographyH5';

export const TypographyP = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, title, ...props }, ref) => {
    return (
      <p
        ref={ref}
        title={title}
        className={cn(typographyVariant({ variant: 'p', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyP.displayName = 'TypographyP';

export const TypographyPBold = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(typographyVariant({ variant: 'pBold', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyPBold.displayName = 'TypographyPBold';

export const TypographyP2 = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(typographyVariant({ variant: 'p2', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyP2.displayName = 'TypographyP2';

export const TypographyP2Bold = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(typographyVariant({ variant: 'p2Bold', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyP2Bold.displayName = 'TypographyP2Bold';

export const TypographyP2SemiBold = React.forwardRef<
  HTMLParagraphElement,
  TypographyProps
>(({ children, className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn(typographyVariant({ variant: 'p2SemiBold', className }))}
      {...props}
    >
      {children}
    </p>
  );
});
TypographyP2SemiBold.displayName = 'TypographyP2SemiBold';

export const TypographyCaption = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(typographyVariant({ variant: 'caption', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyCaption.displayName = 'TypographyCaption';

export const TypographyCaptionBold = React.forwardRef<
  HTMLParagraphElement,
  TypographyProps
>(({ children, className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn(typographyVariant({ variant: 'captionBold', className }))}
      {...props}
    >
      {children}
    </p>
  );
});
TypographyCaptionBold.displayName = 'TypographyCaptionBold';

export const UserData = React.forwardRef<HTMLSpanElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <span ref={ref} className={className} {...props}>
        {children}
      </span>
    );
  }
);
UserData.displayName = 'UserData';

export const TypographyFootNote = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(typographyVariant({ variant: 'footnote', className }))}
        {...props}
      >
        {children}
      </p>
    );
  }
);
TypographyFootNote.displayName = 'TypographyFootNote';

export const TypographyFootNoteBold = React.forwardRef<
  HTMLParagraphElement,
  TypographyProps
>(({ children, className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn(typographyVariant({ variant: 'footnoteBold', className }))}
      {...props}
    >
      {children}
    </p>
  );
});
TypographyFootNoteBold.displayName = 'TypographyFootNoteBold';
